import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-float-label" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "p-error"
}

import { reactive, ref, computed } from 'vue';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';

import { RegistrationField } from '@/types/RegistrationField';
import { createSelfRegistrationValues } from '@/composables/useAuthFlow';


export default /*#__PURE__*/_defineComponent({
  props: {
    fields: null
  },
  emits: ["submit", "error"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'submit', payload: { fields: Record<string, string> }): void;
  (e: 'error', message: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { fields: RegistrationField[] }




const values = reactive<Record<string, string>>(createSelfRegistrationValues(props.fields));
const submitted = ref(false);

const fieldErrors = computed(() => {
  if (!submitted.value) return {} as Record<string, string>;
  const errors: Record<string, string> = {};
  for (const field of props.fields) {
    if (!values[field.name]?.trim()) {
      errors[field.name] = `${field.label} is required`;
    }
  }
  return errors;
});

const updateField = (name: string, value: string) => {
  values[name] = value;
};

const submit = () => {
  if (!props.fields.length) {
    emit('error', 'Self-registration is not available right now.');
    return false;
  }
  submitted.value = true;
  if (Object.keys(fieldErrors.value).length) return false;
  emit('submit', { fields: { ...values } });
  return true;
};

expose({ submit });

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
    return (_openBlock(), _createElementBlock("div", {
      key: field.name,
      class: "field p-3"
    }, [
      _createElementVNode("span", _hoisted_1, [
        (field.type !== 'password')
          ? (_openBlock(), _createBlock(_unref(InputText), {
              key: 0,
              modelValue: _unref(values)[field.name] || '',
              id: field.name,
              type: field.type,
              class: _normalizeClass({ 'p-invalid': !!_unref(fieldErrors)[field.name] }),
              "onUpdate:modelValue": ($event: any) => (updateField(field.name, $event))
            }, null, 8, ["modelValue", "id", "type", "class", "onUpdate:modelValue"]))
          : (_openBlock(), _createBlock(_unref(Password), {
              key: 1,
              modelValue: _unref(values)[field.name] || '',
              id: field.name,
              toggleMask: "",
              feedback: false,
              class: _normalizeClass({ 'p-invalid': !!_unref(fieldErrors)[field.name] }),
              "onUpdate:modelValue": ($event: any) => (updateField(field.name, $event))
            }, null, 8, ["modelValue", "id", "class", "onUpdate:modelValue"])),
        _createElementVNode("label", {
          for: field.name
        }, _toDisplayString(field.label) + "*", 9, _hoisted_2)
      ]),
      (_unref(fieldErrors)[field.name])
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_unref(fieldErrors)[field.name]), 1))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}
}

})